import { render, staticRenderFns } from "./DepartmentStatistics.vue?vue&type=template&id=ff5eb154&scoped=true"
import script from "./DepartmentStatistics.vue?vue&type=script&lang=js"
export * from "./DepartmentStatistics.vue?vue&type=script&lang=js"
import style0 from "./DepartmentStatistics.vue?vue&type=style&index=0&id=ff5eb154&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff5eb154",
  null
  
)

export default component.exports